import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { roundNumber } from '../../lib/utils';

import Card from '../../components/Card';
import PaymentMethodSelect from './PaymentMethodSelect';
import TransactionSummary from './TransactionSummary';
import { steps } from '../step/stepSlice';

export default function PaymentMethods() {
  const { currencies } = useSelector((state) => state);
  const currentStep = useSelector((state) => state.step.step);
  const containerRef = useRef(null);

  useEffect(() => {
    if (currentStep === steps.paymentMethods) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currentStep]);

  const converted = `${roundNumber(currencies.receiver.rate * (1 / currencies.sender.rate), 2)} ${
    currencies.receiver.name
  }`;

  return (
    <div ref={containerRef}>
      {currentStep === steps.paymentMethods && (
        <div className="exchange-info">{`Exchange rate: 1 ${currencies.sender.name} = ${converted}`}</div>
      )}
      <Card
        step={steps.paymentMethods}
        title="Select payment method"
        CollapsedContent={CollapsedContent}
      >
        <div className="payment-methods">
          <PaymentMethodSelect />
          <TransactionSummary />
        </div>
      </Card>
    </div>
  );
}

function CollapsedContent() {
  return (
    <div className="collapsed-content">
      <div className="content selected-value">Selected payment method</div>
    </div>
  );
}
